import { formatDate } from '@fukuri-admins/utils/common/date';
import { useStressAssessmentReportDownload } from '../../hooks';
import { StressAssessmentReportDownloadPresentation } from '../../presentations';

type ComponentProps = React.ComponentProps<typeof StressAssessmentReportDownloadPresentation>;
type HooksReturnType = ReturnType<typeof useStressAssessmentReportDownload>;

type IConvertToStressAssessmentReportDownloadProps = (args: {
  data: HooksReturnType['state']['data'];
  stressAssessmentSummary: HooksReturnType['state']['stressAssessmentSummary'];
  branchStats: HooksReturnType['state']['branchStats'] | undefined;
}) => {
  branches: ComponentProps['branches'];
  targetYearLabel: ComponentProps['targetYearLabel'];
  inspectionYearMonthLabel: ComponentProps['inspectionYearMonthLabel'];
  inspectedCount: ComponentProps['inspectedCount'];
  groupAnalysisCount: ComponentProps['groupAnalysisCount'];
};

export const convertToStressAssessmentReportDownloadProps: IConvertToStressAssessmentReportDownloadProps =
  ({ data, stressAssessmentSummary, branchStats }) => {
    const branches = data.branches.map(({ id, name, code }) => ({
      id,
      label: `${name}（${code}）`,
    }));
    const surveyDate = new Date(
      stressAssessmentSummary.stress_assessment_summary.stress_assessment?.survey_date * 1000
    );
    const inspectionYearMonthLabel = formatDate({ date: surveyDate, formatType: 'yyyy年M月' });

    const parts = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
      year: 'numeric',
      timeZone: 'Asia/Tokyo',
    }).formatToParts(surveyDate);

    const targetYearLabel = parts.map(p => p.value).join('') + '度';

    // 事業所が存在しない場合branchStatsのリクエストは行わないためサマリーのcompleted_countを使用する
    const inspectedCount = branchStats
      ? branchStats.stress_assessment_branch_stats.completed_user_count
      : stressAssessmentSummary.stress_assessment_summary.completed_count;

    return {
      branches,
      targetYearLabel,
      inspectionYearMonthLabel,
      inspectedCount,
      groupAnalysisCount: branches.length,
    };
  };
